import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Home/Mainhometwo/Headertwo";
import Portfolio from "../MenPortfolio/Portfolio";
import Ctaone from "../../Global/Ctaone";
import Footertwo from "../../Home/Mainhometwo/Footertwo";
import Portfoliobred from "../../Global/Portfoliobred";
import BackToTop from '../../Global/BackToTop';

const Main =()=>{
    return(
        <>
        <Preloader/>
         <Headertwo/>
         <Portfoliobred Title="Portfolio" Subtitle="Portfolio"/>
         <Portfolio/>
         <Ctaone/>
         <Footertwo/>
         <BackToTop/>
        </>
    )
}
export default Main;